import ApiService from '../../../util/api';
import { fetchProject } from './fetchProject';

/**
 *
 * @see http://34.192.78.81:9140/swagger-ui/index.html#/CardProjectV2/cloneProject
 *
 * @param {*} projectUUID  string
 * @returns WProjectFullView
 */
export function cloneProject(projectUUID) {
  return (dispatch) =>
    ApiService.post(`/web-api/v2/card-project/${projectUUID}/clone`).then((json) => {
      const { uuid } = json;
      return dispatch(fetchProject(uuid));
    });
}

export function cloneSampleProject(projectUUID, variationUUID, quantity) {
  return (dispatch) => {
    const requestBody = {
      single_sample_project_uuid: projectUUID,
      variation_uuid: variationUUID,
      quantity,
    };
    return ApiService.post(
      `/web-api/v1/card-single-sample/create-project-from-sample`,
      requestBody
    ).then((json) => dispatch(fetchProject(json.uuid)));
  };
}
